<template>
  <b-modal
    ref="bModal"
    size="xs"
    :title="$t('component.printLabelsModal.saveTemplate')"
    centered
    modal-class="save-print-template"
    @hide="onHide"
  >
    <b-row
      v-if="templateFormSaveModal"
      class="py-3 px-4 mb-4"
    >
      <b-col
        cols="12"
        class="d-flex flex-column"
      >
        <div class="form-label">
          <label>{{ $t('component.printLabelsModal.labelName') }}*</label>
        </div>
        <vt-input
          v-model="templateFormSaveModal.title"
          v-validate="'required'"
          class="form-control-sm"
        />
      </b-col>
      <b-col
        cols="12"
        class="d-flex flex-column mt-3"
      >
        <div class="form-label">
          <label>{{ $t('component.printLabelsModal.labelDescription') }}</label>
        </div>
        <b-form-textarea
          v-model="templateFormSaveModal.description"
          rows="3"
          no-resize
        />
      </b-col>
      <b-col cols="12">
        <div class="switch-btn mt-3 p-0 d-flex align-items-center">
          <input
            id="toggleUseByDefault"
            v-model="templateFormSaveModal.toBeUsedByDefault"
            type="checkbox"
            class="offscreen"
            aria-hidden="true"
          >
          <label
            for="toggleUseByDefault"
            class="switch mb-0"
          />
          <span class="ml-2 dark">Plantilla por defecto</span>
        </div>
      </b-col>
    </b-row>
    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-5 text-left">
          <b-button
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </div>
        <div class="col-7 text-right">
          <b-button
            v-if="!selectedTemplateId"
            size="sm"
            class="btn--primary mx-2"
            @click="create"
          >
            <i
              class="fal fa-save mr-2"
              aria-hidden="true"
            />
            {{ $t('global.save') }}
          </b-button>
          <b-button
            v-if="selectedTemplateId"
            size="sm"
            class="btn__outline mr-2"
            @click="create"
          >
            <i
              class="fal fa-save mr-2"
              aria-hidden="true"
            />
            {{ $t('global.save') }}
          </b-button>
          <b-button
            v-if="selectedTemplateId"
            size="sm"
            class="btn--primary"
            @click="update"
          >
            <i
              class="fal fa-arrow-to-bottom mr-2"
              aria-hidden="true"
            />
            {{ $t('component.printLabelsModal.overwrite') }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import batchPrintingDashboardServices from '@/api/resources/common/batchPrintingDashboardServices'
import apiExceptionType from '@/utils/apiExceptionType'
import { cloneDeep } from 'lodash'

export default {
    name: 'SavePrintTemplate',
    props: {
        selectedTemplateId: { type: Number }
    },
    data() {
        return {
            title: '',
            isActive: false,
            selected: null,
            templateFormSaveModal: null
        }
    },
    computed: {
        labId() {
            return this.$store.getters.labId
        }
    },
    methods: {
        show(templateForm) {
            this.templateFormSaveModal = cloneDeep(templateForm)
            this.$refs.bModal.show()
        },
        hide() {
            this.$refs.bModal.hide()
        },
        onHide() {
            this.$_cleanComponentData()
        },
        validate() {
            return this.$validator.validate()
        },
        async validateForm() {
            const validation = await this.validate()
            if (!validation) {
                this.showErrorModalGlobal(this.$t('global.incompleteForm'))
                return false
            }
        },
        async createTemplate(request, overrideToBeUsedByDefault = false) {
            const [err, response] = await this.toCall(batchPrintingDashboardServices.createTemplate(this.labId, request, overrideToBeUsedByDefault))
            if (err) {
                if (err.response.data.code === apiExceptionType.BATCH_PRINTING_TEMPLATE_DUPLICATED) {
                    this.showErrorModalGlobal(this.$t('component.printLabelsModal.duplicatedTemplateName'))
                } else if (err.response.data.code === apiExceptionType.BATCH_PRINTING_TEMPLATE_MORE_THAN_ONE_MARKED_USED_BY_DEFAULT) {
                    const confirmationResponse = await this.showConfirmationModalGlobal(this.$t('component.printLabelsModal.duplicatedDefaultTemplate'))
                    if (confirmationResponse) {
                        await this.createTemplate(true)
                    }
                } else {
                    this.showErrorModalGlobalFromErrorResponse(err)
                }
            } else {
                this.showToastSuccessGlobal(this.$t('component.printLabelsModal.templateCreated'))
                return response
            }
        },
        async updateTemplate(request, overrideToBeUsedByDefault = false) {
            const [err, response] = await this.toCall(batchPrintingDashboardServices.updateTemplate(this.labId, this.selectedTemplateId, request, overrideToBeUsedByDefault))
            if (err) {
                if (err.response.data.code === apiExceptionType.BATCH_PRINTING_TEMPLATE_DUPLICATED) {
                    this.showErrorModalGlobal(this.$t('component.printLabelsModal.duplicatedTemplateName'))
                } else if (err.response.data.code === apiExceptionType.BATCH_PRINTING_TEMPLATE_MORE_THAN_ONE_MARKED_USED_BY_DEFAULT) {
                    const confirmationResponse = await this.showConfirmationModalGlobal(this.$t('component.printLabelsModal.duplicatedDefaultTemplate'))
                    if (confirmationResponse) {
                        await this.updateTemplate(true)
                    }
                } else {
                    this.showErrorModalGlobalFromErrorResponse(err)
                }
            } else {
                this.showToastSuccessGlobal(this.$t('component.printLabelsModal.templateSaved'))
                return response
            }
        },
        mapTemplateToRequest(templateFormSaveModal) {
            return {
                description: templateFormSaveModal.description,
                template: {
                    caseTypeId: templateFormSaveModal.template.caseType && templateFormSaveModal.template.caseType.id,
                    entityCopiesRequestList: templateFormSaveModal.template.entityCopiesRequestList,
                    hasVirtualPortion: templateFormSaveModal.template.hasVirtualPortion,
                    maxValue: templateFormSaveModal.template.maxValue,
                    minValue: templateFormSaveModal.template.minValue,
                    numberOfNextLabels: templateFormSaveModal.template.numberOfNextLabels,
                    rangeLabel: templateFormSaveModal.template.rangeLabel,
                    reportConfigId: templateFormSaveModal.template.reportConfigId,
                    reportModelsList: templateFormSaveModal.template.reportModelsList
                },
                title: templateFormSaveModal.title,
                toBeUsedByDefault: templateFormSaveModal.toBeUsedByDefault
            }
        },
        async create() {
            const request = this.mapTemplateToRequest(this.templateFormSaveModal)
            if (await this.validateForm) {
                const createdTemplate = await this.createTemplate(request)
                if (createdTemplate) {
                    this.$emit('updateTemplates', createdTemplate)
                    this.hide()
                }
            }
        },
        async update() {
            const request = this.mapTemplateToRequest(this.templateFormSaveModal)
            if (await this.validateForm) {
                const updatedTemplate = await this.updateTemplate(request)
                if (updatedTemplate) {
                    this.$emit('updateTemplates', updatedTemplate)
                    this.hide()
                }
            }
        }
    }
}

</script>

<style lang="scss">
    .save-print-template .modal-body {
        padding: 20px 10px;
    }
</style>

<style lang="scss" scoped>
    .save-print-template span {
        font-size: font-size(very-normal);
    }
</style>
